export enum PartReplaceTypes {
  REPLACEMENTS = 'replacements',
  REPLACES = 'replaces'
}
